import { getDomain } from '@sembo-private/utils';
import {
  BrowserTracing,
  captureException,
  init,
  vueRouterInstrumentation,
} from '@sentry/vue';
import type { Plugin } from 'vue';

import router from '../router/routerSetup';

export function createLogger(): Plugin {
  return {
    install(app): void {
      if (getDomain.isProduction) {
        init({
          app,
          dsn: 'https://a325fb177cba4b8394fd1302d9a33c15@o4505316832051200.ingest.sentry.io/4505403376599040',
          enabled: getDomain.isProduction,
          ignoreErrors: [
            'ResizeObserver loop completed with undelivered notifications',
            'ResizeObserver loop limit exceeded',
            'Product card image failed loading from',
            'Network Error',
            'Request failed with status code 404',
            '_AutofillCallbackHandler', // NOTE: Common error in Meta built-in browser for iOS that does not affect user experience: https://developers.facebook.com/community/threads/320013549791141/
          ],
          integrations: [
            new BrowserTracing({
              routingInstrumentation: vueRouterInstrumentation(router),
            }),
          ],
          tracesSampleRate: 0.01,
          sampleRate: 1,
        });
      }
    },
  };
}

export function logException(
  error: unknown,
  value?: Record<string, unknown>
): void;
export function logException(
  message: string,
  value?: Record<string, unknown>
): void;
export function logException(
  errorOrMessage: unknown | string,
  value?: Record<string, unknown>
): void {
  if (import.meta.env.MODE === 'development') {
    console.error(errorOrMessage);
  } else {
    captureException(new Error(getErrorMessage(errorOrMessage)), {
      extra: {
        value,
      },
    });
  }

  function getErrorMessage(error: unknown): string {
    if (isErrorWithMessage(error)) {
      return error.message;
    }

    return String(error);

    function isErrorWithMessage(error: unknown): error is { message: string } {
      return (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof error.message === 'string'
      );
    }
  }
}
